/* Zahra bundle picker — delegated so Horizon rich-text re-renders cannot remove it. */
(function () {
  'use strict';

  if (window.__zfBundleDelegated) return;
  window.__zfBundleDelegated = true;

  var FORM_ID = 'zf-bundle-form';

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function routeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function first(form, selectors) {
    return form.querySelector(selectors);
  }

  function allPanels(form) {
    var panels = form.querySelectorAll('[data-zf-panel]');
    return panels.length ? panels : form.querySelectorAll('.zf-mix-panel');
  }

  function panelForPack(form, pack) {
    var explicit = form.querySelector('[data-zf-panel="' + pack + '"]');
    if (explicit) return explicit;

    var expectedChoices = { '1': 2, '2': 3, '3': 4, '5': 6 };
    var panels = allPanels(form);
    for (var i = 0; i < panels.length; i += 1) {
      if (panels[i].querySelectorAll('input[name="zf_mix"]').length === expectedChoices[pack]) return panels[i];
    }
    return null;
  }

  function showMessage(form, message, type, withLink) {
    var host = first(form, '[data-zf-message], .zf-message');
    if (!host) return;

    host.className = 'zf-message zf-message--' + type;
    host.textContent = message;

    if (withLink) {
      host.appendChild(document.createTextNode(' '));
      var link = document.createElement('a');
      link.href = routeRoot() + 'cart';
      link.textContent = form.getAttribute('data-cart-label') || (document.documentElement.lang === 'ar' ? 'عرض السلة' : 'View cart');
      host.appendChild(link);
    }

    host.hidden = false;
  }

  function setPack(form, input) {
    var total = first(form, '[data-zf-total], .zf-summary strong');
    var shipping = first(form, '[data-zf-ship], .zf-ship');
    var shippingText = first(form, '[data-zf-ship-text], .zf-ship span');
    var message = first(form, '[data-zf-message], .zf-message');
    var panels = allPanels(form);
    var activePanel = panelForPack(form, input.value);
    var fallbackPrices = { '1': 'AED 35', '2': 'AED 60', '3': 'AED 70', '5': 'AED 105' };

    if (total) total.textContent = input.getAttribute('data-price') || fallbackPrices[input.value] || '';
    if (shippingText && input.getAttribute('data-ship')) shippingText.textContent = input.getAttribute('data-ship');
    if (shipping) shipping.classList.toggle('zf-ship--free', input.getAttribute('data-ship-free') === 'true');

    Array.prototype.forEach.call(panels, function (panel) {
      var active = panel === activePanel;
      panel.hidden = !active;
      if (!active) {
        Array.prototype.forEach.call(panel.querySelectorAll('input[name="zf_mix"]'), function (choice) {
          choice.checked = false;
        });
      }
    });

    if (message) message.hidden = true;
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      var id = component.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) ids.push('cart-drawer-section');
    return ids;
  }

  function numberFromText(value) {
    var match = String(value || '').replace(/,/g, '').match(/\d+/);
    return match ? Number(match[0]) : 0;
  }

  function currentCartCount() {
    var candidates = [
      document.querySelector('cart-icon [ref="cartItemCount"]'),
      document.querySelector('cart-icon .cart-bubble__text-count'),
      document.querySelector('.theme-drawer__badge')
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      var count = candidates[i] && numberFromText(candidates[i].textContent);
      if (count) return count;
    }
    return 0;
  }

  function countFromSections(sections, fallback) {
    if (!sections) return fallback;
    var parser = new DOMParser();
    var values = Object.keys(sections);
    for (var i = 0; i < values.length; i += 1) {
      if (!sections[values[i]]) continue;
      var doc = parser.parseFromString(sections[values[i]], 'text/html');
      var countNode = doc.querySelector('[ref="cartItemCount"], .theme-drawer__badge, .cart-bubble__text-count');
      var count = countNode && numberFromText(countNode.textContent);
      if (count) return count;
    }
    return fallback;
  }

  function dispatchCartEvent(selected, requestPromise) {
    var event = new Event('shopify:cart:lines-update', { bubbles: true });
    event.action = 'add';
    event.context = 'product';
    event.lines = [{ merchandiseId: selected.value, quantity: 1 }];
    event.promise = requestPromise;
    document.dispatchEvent(event);
  }

  function addToCart(form) {
    var button = first(form, '.zf-add-button');
    var pack = first(form, 'input[name="zf_pack"]:checked');
    var panel = pack ? panelForPack(form, pack.value) : first(form, '[data-zf-panel]:not([hidden]), .zf-mix-panel:not([hidden])');
    var selected = panel && panel.querySelector('input[name="zf_mix"]:checked');

    if (!selected) {
      showMessage(form, form.getAttribute('data-validation') || (document.documentElement.lang === 'ar' ? 'اختاري تركيبتكِ أولاً.' : 'Choose your mix first.'), 'error', false);
      if (panel && panel.scrollIntoView) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (button && button.disabled) return;

    var originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = form.getAttribute('data-adding') || (document.documentElement.lang === 'ar' ? 'جارٍ الإضافة…' : 'Adding…');
    }
    var message = first(form, '[data-zf-message], .zf-message');
    if (message) message.hidden = true;

    var previousCount = currentCartCount();
    var sectionIds = cartSectionIds();
    var request = fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(selected.value), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok && !data.status, data: data };
      });
    });

    var cartEventPromise = request.then(function (result) {
      var sections = result.data && result.data.sections;
      var totalQuantity = result.ok ? countFromSections(sections, previousCount + 1) : previousCount;
      return {
        cart: { totalQuantity: totalQuantity },
        detail: {
          didError: !result.ok,
          items: (result.data && result.data.items) || [],
          itemCount: 1,
          sections: sections || {},
          source: 'zahra-bundle-picker'
        }
      };
    });

    dispatchCartEvent(selected, cartEventPromise);

    request
      .then(function (result) {
        if (!result.ok) {
          var errorText = result.data && (result.data.description || result.data.message);
          showMessage(form, errorText || form.getAttribute('data-error') || 'Something went wrong.', 'error', false);
          return;
        }
        showMessage(form, form.getAttribute('data-success') || (document.documentElement.lang === 'ar' ? 'تمت الإضافة إلى سلتكِ.' : 'Added to your cart.'), 'success', true);
      })
      .catch(function () {
        showMessage(form, form.getAttribute('data-error') || (document.documentElement.lang === 'ar' ? 'تعذرت الإضافة. حاولي مرة أخرى.' : 'Could not add this mix. Please try again.'), 'error', false);
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      });
  }

  document.addEventListener('change', function (event) {
    var input = closest(event.target, 'input[name="zf_pack"]');
    if (!input) return;
    var form = closest(input, '#' + FORM_ID);
    if (form) setPack(form, input);
  }, true);

  document.addEventListener('click', function (event) {
    var button = closest(event.target, '.zf-add-button');
    if (!button) return;
    var form = closest(button, '#' + FORM_ID);
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== FORM_ID) return;
    event.preventDefault();
    addToCart(event.target);
  }, true);

  function init() {
    var form = document.getElementById(FORM_ID);
    if (!form) return;
    form.setAttribute('onsubmit', 'return false;');
    var button = first(form, '.zf-add-button');
    if (button) button.type = 'button';
    var selectedPack = first(form, 'input[name="zf_pack"]:checked') || first(form, 'input[name="zf_pack"]');
    if (selectedPack) {
      selectedPack.checked = true;
      setPack(form, selectedPack);
    }
  }

  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  window.addEventListener('load', init, { once: true });
  setTimeout(init, 800);
  setTimeout(init, 2000);
})();
